import React from 'react';

import type { HNSkjemaFrontend } from 'src/types/Resources';

import HelpTriggerIcon from '@helsenorge/designsystem-react/components/HelpTriggerIcon';

type Props = {
  resources?: HNSkjemaFrontend;
  opening: boolean;
};

const HelpButton = ({ resources, opening }: Props): React.JSX.Element => {
  return (
    <HelpTriggerIcon
      testId="help-button"
      aria-expanded={opening}
      ariaLabel={resources ? resources.helpButtonTooltip : undefined}
      size="large"
    />
  );
};
export default HelpButton;
